import { render } from "./NewLibraryDocument.vue?vue&type=template&id=cd76d27e&scoped=true&ts=true"
import script from "./NewLibraryDocument.vue?vue&type=script&lang=ts"
export * from "./NewLibraryDocument.vue?vue&type=script&lang=ts"

import "./NewLibraryDocument.vue?vue&type=style&index=0&id=cd76d27e&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd76d27e"]])

export default __exports__